import { render, staticRenderFns } from "./DocsAllocations.vue?vue&type=template&id=2bc9ecb9&scoped=true"
import script from "./DocsAllocations.vue?vue&type=script&lang=js"
export * from "./DocsAllocations.vue?vue&type=script&lang=js"
import style0 from "./DocsAllocations.vue?vue&type=style&index=0&id=2bc9ecb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9ecb9",
  null
  
)

export default component.exports